import { COLOR_PALETTE, mediaQuery } from 'constants/ui';

export const inputContainerStyles = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: '4px',
  [mediaQuery.mobile]: {
    gap: '6px',
  },
};

export const inputFieldStyles = {
  flex: 1,

  '& .MuiOutlinedInput-root': {
    borderRadius: ({ shape }) => shape.radius.l,
    padding: '9px 14px',
  },
};

const actionButtonBaseStyles = {
  minWidth: '40px',
  width: '48px',
  height: '40px',
  borderRadius: ({ shape }) => shape.radius.l,
  padding: 0,
  color: COLOR_PALETTE.GRAY[1],

  [mediaQuery.mobile]: {
    width: '44px',
  },
};

export const sendButtonStyles = {
  ...actionButtonBaseStyles,
  backgroundColor: COLOR_PALETTE.BLUE[7],

  '&:hover': {
    backgroundColor: COLOR_PALETTE.BLUE[8],
  },

  '&.Mui-disabled': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.text.placeholder,
  },
};

export const stopButtonStyles = {
  ...actionButtonBaseStyles,
  backgroundColor: ({ palette }) => palette.error.main,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.error.dark,
  },
};

export const stopIconSquareStyles = {
  width: '10px',
  height: '10px',
  borderRadius: '2px',
  backgroundColor: COLOR_PALETTE.GRAY[1],
};
